import React, { createContext, useContext, useReducer } from "react";

const AnalyticsOverviewContext = createContext();

export const useAnalyticsOverview = () => useContext(AnalyticsOverviewContext);

const initialState = {
  open: false,
  activeTab: 0,
};

const analyticsOverviewReducer = (state, action) => {
  switch (action.type) {
    case "OPEN_MODAL":
      return { ...state, open: true };
    case "CLOSE_MODAL":
      return { ...state, open: false };
    case "TOGGLE_MODAL":
      return { ...state, open: !state.open };
    case "SET_TAB":
      return { ...state, activeTab: action.payload };
    default:
      return state;
  }
};

export const AnalyticsOverviewProvider = ({ children }) => {
  const [state, dispatch] = useReducer(analyticsOverviewReducer, initialState);

  return (
    <AnalyticsOverviewContext.Provider value={{ state, dispatch }}>
      {children}
    </AnalyticsOverviewContext.Provider>
  );
};
